export const RECOMMENDATIONS_MANIFEST_INFO_SETTING_KEY = 'recommendationsManifestInfo';
